module.exports = __webpack_public_path__ + "static/media/spis-dzialow-i-tematow-informatyka-1.db8e7772.pdf";